import type { FutebolVotacaoJogo } from '@/shared/types';
import { selecionarVencedorAtivo } from './selecionarCandidatos';

export function ordenarPorVotos(jogos: FutebolVotacaoJogo[]): FutebolVotacaoJogo[] {
  return [...jogos].sort((a, b) => b.votos - a.votos || a.fixture_id - b.fixture_id);
}

export function derivarCandidatos(
  jogos: FutebolVotacaoJogo[],
  ultimoCicloIds: number[],
): {
  ativos: FutebolVotacaoJogo[];
  winners: FutebolVotacaoJogo[];
  totalVotos: number;
  lider: FutebolVotacaoJogo | null;
  vencedor: FutebolVotacaoJogo | null;
} {
  const ordenados = ordenarPorVotos(jogos);
  const ativos = ordenados.filter((j) => !j.vencedor);
  const winners = ordenados.filter((j) => j.vencedor);
  const totalVotos = ativos.reduce((s, j) => s + j.votos, 0);
  const lider = ativos.length > 0 && ativos[0].votos > 0 ? ativos[0] : null;
  const vencedor = selecionarVencedorAtivo(winners, ultimoCicloIds);
  return { ativos, winners, totalVotos, lider, vencedor };
}
